export default __webpack_public_path__ + "static/media/wtm_logo.95d126b2.jpeg";